import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Tab from "./Tab";
import TabBar from "./TabBar";
import FileTabBar from "../../Tabs/FileTabBar";
import FileTab from "../../Tabs/FileTab";
import GridView from "./ContentViews/Grid";
import UploadFileView from "./ContentViews/UploadFile";
import FileRainbowView from "./ContentViews/FileRainbow";
import LoadingView from "./ContentViews/Loading";
import { formatDate } from "../../../utils/Utils";
import { insertFile } from "../../../utils/Files";
import {
  getAll as getAllFiles,
  destroy as deleteById,
} from "../../../data/Files";
import { getById } from "../../../services/Layouts";

export default function Index(props) {
  let [layout, setLayout] = useState(null);
  let [registerFields, setRegisterFields] = useState([]);
  let [registerHeaders, setRegisterHeaders] = useState([]);
  let [tab, setTab] = useState("");
  let [screenHeight, setScreenHeight] = useState(window.innerHeight);
  let [files, setFiles] = useState([]);
  let [fileId, setFileId] = useState(0);
  let [fileContent, setFileContent] = useState("");
  let [viewMode, setViewMode] = useState(1);
  let [loading, setLoading] = useState(true);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
    listAllFiles();
    setLayout(props.layout);
    //getLayout(props.layoutId);
    //console.log(props.layout);
  }, []);
  //console.log(layout);
  const handleResize = () => {
    setScreenHeight(window.innerHeight);
  };

  let listAllFiles = async () => {
    let files = await getAllFiles();
    setFiles(files);
  };

  let handleUploadFile = async (e) => {
    const filename = e.target.files[0].name;
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      await insertFile(props.layoutId, filename, text);
      listAllFiles();
    };

    reader.readAsText(e.target.files[0]);
  };

  let handleClickAddFile = async () => {
    setFileId(0);
    localStorage.setItem("lastClickedFileForLayoutId" + props.layoutId, 0);
  };

  let handleLoadFile = async (fileId, fileContent, _viewMode = viewMode) => {
    setLoading(true);
    setFileId(fileId);
    setFileContent(fileContent);
    setRegisterFields([]);
    setRegisterHeaders([]);
    localStorage.setItem("lastClickedLayout", props.layoutId);
    localStorage.setItem("lastClickedFileForLayoutId" + props.layoutId, fileId);
    if (_viewMode === 1) {
      await generateFields(fileContent);
      await generateRegisterHeaders();
      await getLastClickedTabByFileId(fileId);
      setLoading(false);
    } else if (_viewMode === 2) {
      //await generateFileRainbow(fileContent);
      setLoading(false);
    }
  };

  let handleDeleteFile = async (fileId) => {
    await deleteById(fileId);
    setFileId(0);
    listAllFiles();
  };
  /* 
  let getLayout = async (layoutId) => {
    let layout = null;

    await getById(layoutId).then((data) => {
      layout = data.data;
    });

    setLayout(layout);
    return layout;
  };
 */
  let generateFields = async (fileContent) => {
    let registerFields = [];
    let lineNumber = 0;
    const registerLength = Object.keys(layout.registers)[0]?.length || 0;

    await Promise.all(
      layout &&
        fileContent.split("\n").map(function (line) {
          lineNumber++;

          let key = line.substring(0, registerLength);
          let registerName =
            key && layout.registers[key] && layout.registers[key].name;
          let fields = { id: lineNumber, line: lineNumber };

          key &&
            layout.registers[key] &&
            layout.registers[key].fields.length > 0 &&
            layout.registers[key].fields.map(function (field) {
              let fieldValue = line.substring(
                field.index === 0 ? 0 : field.index - 1,
                field.index + field.size - 1,
              );

              if (field.type === "number") {
                fields[field.name] = parseInt(fieldValue.trim());
              } else if (field.type && field.type.substring(0, 4) === "date") {
                fields[field.name] = formatDate(fieldValue, field.type);
              } else {
                fields[field.name] = fieldValue.trim();
              }
            });
          if (!registerFields[registerName]) {
            registerFields[registerName] = [];
          }
          registerFields[registerName] =
            registerFields[registerName].concat(fields);
          setRegisterFields(registerFields);
        }),
    );
  };

  let generateRegisterHeaders = async () => {
    let registerHeaders = [];

    await Promise.all(
      layout &&
        Object.keys(layout.registers).map((key) => {
          let name = layout.registers[key].name;
          let fields = layout.registers[key].fields;

          let columns = [
            {
              field: "line",
              headerName: "Linha",
              type: "number",
              minWidth: 70,
              //hide: true,
            },
          ];

          fields &&
            fields.map((item) => {
              let minWidth =
                (item.name.length > item.size ? item.name.length : item.size) *
                11;
              let type = item.type;

              if (type === undefined) {
                type = "string";
              } else if (type.substring(0, 4) === "date") {
                type = "date";
              }
              columns = columns.concat({
                field: item.name,
                headerName: item.name,
                minWidth: minWidth,
                type: type,
              });
            });
          if (!registerHeaders[name]) {
            registerHeaders[name] = [];
          }
          registerHeaders[name] = columns;
          setRegisterHeaders(registerHeaders);
        }),
    );
  };

  let handleClickTab = (key) => {
    setTab(key);
    localStorage.setItem("lastCLickedTabForFile" + fileId, key);
  };

  let getLastClickedTabByFileId = async (fileId) => {
    let tab = localStorage.getItem("lastCLickedTabForFile" + fileId);
    if (tab !== null) {
      setTab(tab);
    } else {
      await Promise.all(
        layout &&
          Object.keys(layout.registers).map((key) => {
            if (key !== "RegSize") setTab(key.toString());
          }),
      );
    }
  };

  let handleViewMode = async (viewMode) => {
    setViewMode(viewMode);
    handleLoadFile(fileId, fileContent, viewMode);
  };

  return (
    <div
      component="main"
      style={{
        flexGrow: 1,
        overflow: "hidden",
      }}
      mt={4}
    >
      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Box
          sx={{
            marginTop: "40px",
            padding: 1,
            userSelect: "none",
          }}
        >
          <FileTabBar
            handleClickAddFile={handleClickAddFile}
            enableAddFileButton={fileId === 0}
          >
            {files &&
              files.map((item) => {
                return (
                  props.layoutId === item["layoutId"] && (
                    <>
                      <FileTab
                        item={item}
                        handleDeleteFile={handleDeleteFile}
                        selected={fileId === item.id}
                        handleAction={() =>
                          handleLoadFile(item["id"], item["fileContent"])
                        }
                      />
                    </>
                  )
                );
              })}
          </FileTabBar>

          <TabBar
            viewMode={viewMode}
            handleViewMode={handleViewMode}
            showViwModeButtons={
              fileId > 0 &&
              props.layoutId ===
                parseInt(localStorage.getItem("lastClickedLayout"))
            }
          >
            {fileId > 0 &&
              props.layoutId ===
                parseInt(localStorage.getItem("lastClickedLayout")) &&
              viewMode === 1 &&
              layout && (
                <>
                  {Object.keys(layout.registers).map((key) => {
                    let name = layout.registers[key].name;

                    if (name !== undefined) {
                      return (
                        <span onClick={() => handleClickTab(key)}>
                          <Tab
                            selected={tab === key}
                            keyName={key}
                            name={name}
                          />
                        </span>
                      );
                    }
                  })}
                </>
              )}
          </TabBar>
        </Box>

        {loading && fileId !== 0 && <LoadingView />}

        {fileId > 0 &&
          !loading &&
          viewMode === 2 &&
          props.layoutId ===
            parseInt(localStorage.getItem("lastClickedLayout")) && (
            <FileRainbowView
              fileContent={fileContent}
              layout={layout}
              height={600}
              lineHeight={24}
              screenHeight={screenHeight}
            />
          )}

        {fileId > 0 &&
          !loading &&
          props.layoutId ===
            parseInt(localStorage.getItem("lastClickedLayout")) &&
          viewMode === 1 &&
          layout && (
            <>
              {Object.keys(layout.registers).map((key) => {
                let name = layout.registers[key].name;
                if (name !== undefined) {
                  return (
                    <GridView
                      visible={tab === key}
                      screenHeight={screenHeight}
                      rows={
                        registerFields === undefined
                          ? []
                          : registerFields[name] === undefined
                            ? []
                            : registerFields[name]
                      }
                      columns={
                        registerHeaders === undefined
                          ? []
                          : registerHeaders[name] === undefined
                            ? []
                            : registerHeaders[name]
                      }
                    />
                  );
                }
              })}
            </>
          )}
        {(fileId === 0 ||
          props.layoutId !==
            parseInt(localStorage.getItem("lastClickedLayout"))) && (
          <UploadFileView handleUploadFile={handleUploadFile} />
        )}
      </Box>
    </div>
  );
}
